module.exports = __webpack_public_path__ + "static/media/connection-lost-illustration.1af369b3.png";